export default __webpack_public_path__ + "static/media/ukrainego-screenshot-06.c673595f.png";